import script from "./AgreementListComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AgreementListComponent.vue?vue&type=script&setup=true&lang=js"

import "./AgreementListComponent.vue?vue&type=style&index=0&id=06aa88a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06aa88a1"]])

export default __exports__